var _path, _path2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3385 6.18065L12.3609 6.34391L13.4136 6.64098L34.3994 14.2703L35.3179 14.645L36.1995 15.1207L37.0377 15.687L37.8257 16.3336L38.5565 17.0508L39.223 17.829L39.8181 18.6588L40.3341 19.531L40.7632 20.4363L41.0974 21.3657L41.3281 22.3101L41.4464 23.2601L41.8201 43.9818L41.8202 43.9824L41.6943 44.9891L41.4464 45.9203L41.0829 46.7678L40.6102 47.523L40.0349 48.1771L39.364 48.7205L38.6045 49.1438L37.764 49.437L36.8503 49.5902L35.8719 49.5935L34.8376 49.4368L11.6507 44.4925L10.5178 44.2307L9.32602 43.7199L8.18681 42.9802L7.16709 42.211L6.23582 41.3328L5.40521 40.3605L4.68709 39.3092L4.0928 38.1947L3.63319 37.0324L3.3185 35.8383L3.1582 34.6277L3.16132 33.4166L5.00274 11.1045L5.15054 10.1332L5.43802 9.25686L5.85288 8.48033L6.38297 7.80806L7.01633 7.24419L7.74135 6.79259L8.54674 6.45693L9.42162 6.24072L10.3555 6.14746L11.3385 6.18065ZM41.8201 43.9818L41.4464 23.2601L41.8177 42.908L41.8201 43.9818Z",
    fill: "url(#paint0_linear_2513_65574)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62641 4.27105L9.47862 5.24232L7.73126 29.3095L7.72815 30.5207L7.8884 31.7312L8.20313 32.9254L8.66275 34.0876L9.25703 35.2022L9.97515 36.2534L10.8058 37.2258L11.737 38.104L12.7567 38.8732L13.8524 39.5189L15.0111 40.0274L16.2201 40.3854L41.0174 46.0019L42.0517 46.1586L43.0301 46.1554L43.9437 46.0021L44.7842 45.7089L43.9474 46.2049L43.1908 46.6266L42.3913 47.1009L43.1904 46.6269L43.1908 46.6266L43.9474 46.2049L44.7842 45.7089L45.5438 45.2856L43.9481 46.2044L43.9477 46.2047L43.9474 46.2049L43.1908 46.6266L42.3913 47.1009L40.873 47.9752L39.3914 48.8284L38.6427 49.2461L37.818 49.5396L36.9251 49.6992L35.9725 49.7152L34.969 49.5781L11.0413 44.5216L9.88065 44.1953L8.77107 43.7241L7.72465 43.1205L6.75338 42.3975L5.86901 41.5687L5.083 40.6481L4.40642 39.6502L3.84994 38.5895L3.42372 37.4808L3.13739 36.3389L3 35.1786L3.01996 34.0146L5.04911 10.7522L5.20618 9.80759L5.49722 8.95173L6.9746 6.84764L7.49978 6.18169L8.592 4.8044L9.7112 3.39308L10.8578 1.94727L10.3288 2.61816L9.9139 3.3947L9.62641 4.27105Z",
    fill: "url(#paint1_linear_2513_65574)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2513_65574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8137 0.31835L16.8361 0.481602L17.8888 0.77868L39.5654 8.21474L40.4838 8.58944L41.3655 9.06515L42.2037 9.63137L42.9916 10.278L43.7224 10.9952L44.389 11.7734L44.9841 12.6032L45.5001 13.4754L45.9292 14.3807L46.2634 15.3101L46.494 16.2545L46.6123 17.2046L47.9994 40.5468L47.9994 40.5474L47.8735 41.554L47.6256 42.4852L47.2621 43.3327L46.7894 44.088L46.2141 44.742L45.5432 45.2854L44.7837 45.7087L43.9433 46.0019L43.0295 46.1552L42.0512 46.1584L41.0168 46.0018L16.22 40.3854L15.0871 40.1235L13.8954 39.6128L12.7561 38.873L11.7364 38.1038L10.8052 37.2256L9.97455 36.2533L9.25643 35.2021L8.66214 34.0875L8.20253 32.9252L7.88783 31.7311L7.72754 30.5206L7.73065 29.3094L9.47801 5.24218L9.62581 4.27091L9.91329 3.39456L10.3282 2.61802L10.8582 1.94575L11.4916 1.38189L12.2166 0.930287L13.022 0.594622L13.8969 0.378413L14.8308 0.285156L15.8137 0.31835ZM47.9994 40.5468L46.6123 17.2046L47.997 39.473L47.9994 40.5468Z",
    fill: "url(#paint2_linear_2513_65574)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4975 40.5311L47.3816 41.4583L47.1518 42.3215L46.8178 43.1001L46.3871 43.7883L45.8666 44.3801L45.2621 44.8697L44.5781 45.2509L43.8187 45.5158L42.987 45.6553L42.088 45.6583L41.1096 45.5101L16.3326 39.8982L16.3305 39.8977L15.2431 39.6464L14.1317 39.1701L13.0432 38.4633L12.0595 37.7212L11.1678 36.8803L10.3722 35.949L9.68474 34.9426L9.11667 33.8772L8.67844 32.769L8.37936 31.6342L8.22762 30.4882L8.23061 29.3282L9.97527 5.29798L10.1139 4.38724L10.3748 3.59177L10.7483 2.89277L11.2236 2.28992L11.7922 1.78372L12.4465 1.37618L13.1791 1.07085L13.9821 0.872386L14.8473 0.785998L15.7657 0.817013L16.7284 0.970741L17.7397 1.25612L39.3897 8.68307L40.2701 9.04224L41.1062 9.49338L41.9045 10.0327L42.6572 10.6504L43.3568 11.3369L43.9953 12.0823L44.5649 12.8767L45.0581 13.7102L45.4669 14.5728L45.7839 15.4544L46.0014 16.345L46.1142 17.2503L47.4975 40.5311Z",
    stroke: "url(#paint3_linear_2513_65574)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2513_65574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1141 19.4014L19.0883 18.3584L17.9336 19.595L18.1141 19.4014ZM41.6176 20.256L28.507 29.9695L28.5059 29.9704L28.2751 30.1131L28.0257 30.2152L27.7615 30.2773L27.4861 30.3001L27.2031 30.2845L26.9164 30.231L26.6297 30.1406L26.3469 30.014L26.0718 29.8523L25.6632 30.3789L25.2546 30.9055L25.5343 31.0295L25.818 31.1177L26.102 31.1693L26.3825 31.1835L26.6557 31.1597L26.9179 31.097L27.1656 30.9948L27.3952 30.8525L40.4643 21.1632L40.465 21.1627L41.6176 20.256ZM18.907 18.5529L17.9336 19.595L17.7893 19.8142L17.6814 20.0552L17.6106 20.3146L17.5771 20.5886L17.5814 20.8735L17.6237 21.1654L17.7043 21.4606L17.8236 21.7551L17.9816 22.0451L18.1785 22.3266L24.2525 30.0706L24.4778 30.3282L24.7225 30.5539L24.9827 30.7467L25.2546 30.9055L25.6632 30.3789L26.0718 29.8523L25.8083 29.6563L25.5604 29.4271L25.3318 29.1657L19.1663 21.3124L18.9662 21.027L18.8055 20.7334L18.6838 20.4353L18.6011 20.1368L18.5571 19.8418L18.5516 19.5541L18.5842 19.2776L18.6545 19.0161L18.7623 18.7733L18.907 18.5529ZM18.907 18.5529L19.0883 18.3584L17.9336 19.595L18.907 18.5529Z",
    fill: "url(#paint4_linear_2513_65574)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5108 17.5409L41.6851 17.7904L41.8298 18.0459L41.9449 18.3045L42.0303 18.5632L42.0858 18.8188L42.1112 19.0681L42.1064 19.3082L42.0709 19.5358L42.0046 19.7476L41.9072 19.9403L41.7784 20.1108L41.6178 20.2556L28.5069 29.9693L28.5061 29.9699L28.2752 30.1126L28.0259 30.2147L27.7617 30.2768L27.4862 30.2997L27.2033 30.284L26.9165 30.2306L26.6298 30.1401L26.347 30.0136L26.072 29.8519L25.8085 29.6559L27.0208 24.7922L38.8493 16.6559L39.0394 16.5502L39.2457 16.4811L39.4649 16.4473L39.694 16.4476L39.9298 16.4808L40.1692 16.5457L40.4092 16.6412L40.6466 16.7663L40.8784 16.9198L41.1018 17.1007L41.3136 17.308L41.5108 17.5409ZM18.5844 19.2771L18.6547 19.0157L18.7624 18.773L19.5512 18.0651L20.6636 17.9514L20.9554 18.016L21.2452 18.1155L21.5295 18.2486L21.8044 18.4143L22.0664 18.6116L22.3119 18.8394L22.5373 19.0968L27.0208 24.7922L25.8085 29.6559L25.5605 29.4266L25.332 29.1652L19.1664 21.3119L18.9664 21.0266L18.8056 20.7329L18.684 20.4348L18.6013 20.1363L18.5573 19.8413L18.5518 19.5537L18.5844 19.2771ZM20.6636 17.9514L20.3735 17.9227L20.0889 17.9312L19.8135 17.9783L19.5512 18.0651L20.6636 17.9514ZM19.5512 18.0651L19.306 18.193L19.0885 18.3579L18.9071 18.5524L18.7624 18.773L19.5512 18.0651Z",
    fill: "url(#paint5_linear_2513_65574)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2513_65574",
    x: -5.27246,
    y: -12.7148,
    width: 66.2715,
    height: 71.873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2513_65574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2513_65574",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2513_65574",
    x: 0.871831,
    y: 11.8069,
    width: 50.5202,
    height: 40.7224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.71229,
    dy: 8.35266
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.49651
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.103333 0 0 0 0 0.4104 0 0 0 0 0.43 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2513_65574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2513_65574",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2513_65574",
    x1: 4.27958,
    y1: 52.3212,
    x2: 39.6323,
    y2: 9.35794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.320833,
    stopColor: "#45AF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58125,
    stopColor: "#45AF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89375,
    stopColor: "#45AF49",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2513_65574",
    x1: -7.44824,
    y1: 8.42096,
    x2: 41.992,
    y2: 57.7958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98DE9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35896,
    stopColor: "#31B035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683604,
    stopColor: "#0AAE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85C688"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2513_65574",
    x1: 9.00736,
    y1: 47.885,
    x2: 44.3601,
    y2: 4.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.320833,
    stopColor: "#45AF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685417,
    stopColor: "#45AF49",
    stopOpacity: 0.9405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89375,
    stopColor: "#45AF49",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2513_65574",
    x1: 7.65503,
    y1: 41.738,
    x2: 46.7763,
    y2: 8.9181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.180663,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533255,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2513_65574",
    x1: 16.4559,
    y1: 8.9192,
    x2: 16.7377,
    y2: 34.1069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.301696,
    stopColor: "#6FBA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993284,
    stopColor: "#4EBE52",
    stopOpacity: 0.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2513_65574",
    x1: 28.4352,
    y1: 34.5505,
    x2: 41.1239,
    y2: 11.9622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644664,
    stopColor: "white",
    stopOpacity: 0.57
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.784444508fa54bd8f46fbf1cbbb15e7c.svg";
export { ForwardRef as ReactComponent };